module.exports = __webpack_public_path__ + "img/bracket-11.4072867d.svg";